import { Credential } from './../../models/authentication.model';
import { LoggedUser, User } from 'src/app/models/Users';
import { StoreAction } from '../../models/rootState.model';
import { Entity } from 'src/app/models/entities.model';
import { User as fUser } from '@angular/fire/auth';

// tslint:disable: class-name

export const AUTH_ACTION_TYPES = {

  LOAD_CURRENT_FIREBASE_USER: '[Auth Guard] -Load current firebase user-',
  LOAD_CURRENT_FIREBASE_USER_SUCCESS: '[Auth initial_effec$] -Current firebase user setted-',
  LOAD_CURRENT_FIREBASE_USER_EMPTY: '[Auth initial_effect$] -Current firebase user is empty-',

  SIGNIN: '[Auth Signin] -Signin requested-',
  SIGNIN_FIREBASE_SUCCESS: '[Auth signin$] -Signed in successfully @firebase-',

  SIGNIN_WITH_FACEBOOK: '[Auth Signin] -Signin with facebook requested-',
  SIGNIN_WITH_FACEBOOK_SUCCESS: '[Auth SigninWithFacebook$] -Signin with facebook success-',

  SIGNIN_WITH_GOOGLE: '[Auth Signin] -Signin with google requested-',
  SIGNIN_WITH_GOOGLE_SUCCESS: '[Auth SigninWithGoogle$] -Signin with google success-',

  USER_DATA_UPDATED_BY_STARTUP: '[Auth startup] -User data changed-',
  USER_DATA_UPDATED_BY_FORM: '[Auth profile] -User data changed by form service-',
  USER_DATA_ENTITY_ADDED: '[Auth entity_creation_flow] -new entity added-',
  USER_DATA_RELOADED: '[Auth profile] -User data reloaded-',
  USER_DATA_SET: '[Auth user] -atualizar informações do LOGGED_USER-',
  RELOAD: '[Auth Reload] -Reload User requested-',
  SET_ADMIN_ACCESS: '[Context Changer] -set Admin Access-',

  RETRIEVE_LOGGED_USER_DATA: '[Auth Signin$] -Retrieve user data from server-',
  RETRIEVE_LOGGED_USER_DATA_SUCCESS: '[Auth getUserData$] -User data retrieved-',

  EMAIL_NOT_VERIFIED: '[Auth signin$] -Email not verified-',
  VALIDATION_EMAIL_SENT: '[Auth signin$] -Validation email sent-',
  VALIDATION_EMAIL_SKIP: '[Auth signin$] -Validation email skip-',

  SIGNOUT: '[Auth header] -Signout-',
  SIGNOUT_SUCCESS: '[Auth signout$] -Signed out-',

  SIGNUP: '[Auth Signup] -signup requested-',
  SIGNUP_SUCCESS: '[Auth signup$] -Signup suceess-',

  IS_LOADING: '[Auth] -Is Loading-',
  IS_NOT_LOADING: '[Auth] -Is not loading-',

  IMAGE_PROFILE_CHANGED: '[User Profile] image changed',

  GCM_LOADED: '[Auth GCM] - GCM is loaded',

  AUTH_ERROR: '[Auth] -Auth Error-'
};

export class AuthError extends Error {
  constructor(public error: Error, public extra?: any) {
    super(error.message);
  }
}

export class Action_Auth_Error implements StoreAction<Error> {
  readonly type = AUTH_ACTION_TYPES.AUTH_ERROR;

  constructor(public payload: AuthError) { }
}

export class Action_Auth_GCM_Loaded implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.GCM_LOADED;
}

export class Action_Auth_LoadCurrentFirebaseUser implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER;
}

export class Action_Auth_LoadCurrentFirebaseUser_Success implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER_SUCCESS;
  constructor(public payload: fUser) { }
}

export class Action_Auth_LoadCurrentFirebaseUser_Empty implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER_EMPTY;
}

export class Action_Auth_Signin implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNIN;
  constructor(public payload: Credential) { }
}

export class Action_Auth_Reload implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.RELOAD;
  constructor() { }
}

export class Action_Auth_Signin_Firebase_Success implements StoreAction<fUser> {
  readonly type = AUTH_ACTION_TYPES.SIGNIN_FIREBASE_SUCCESS;
  constructor(public payload: fUser) { }
}

export class Action_Auth_Signup implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNUP;
  constructor(public payload: Credential) { }
}

export class Action_Auth_Signup_Success implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNUP_SUCCESS;
}

export class Action_Auth_EmailNotVerified implements StoreAction<fUser> {
  readonly type = AUTH_ACTION_TYPES.EMAIL_NOT_VERIFIED;
  constructor(public payload: fUser) { }
}

export class Action_Auth_ValidationEmailSent implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.VALIDATION_EMAIL_SENT;
}

export class Action_Auth_ValidationEmailSkip implements StoreAction<fUser> {
  readonly type = AUTH_ACTION_TYPES.VALIDATION_EMAIL_SKIP;
}

export class Action_Auth_UserDataChangedByStartup implements StoreAction<User> {
  readonly type = AUTH_ACTION_TYPES.USER_DATA_UPDATED_BY_STARTUP;
  constructor(public payload: User) { }
}

export class Action_Auth_UserDataChangedByProfileForm implements StoreAction<User> {
  readonly type = AUTH_ACTION_TYPES.USER_DATA_UPDATED_BY_FORM;
  constructor() { }
}

export class Action_Auth_SetUserData implements StoreAction<Partial<LoggedUser>> {
  readonly type = AUTH_ACTION_TYPES.USER_DATA_SET;
  constructor(public payload: Partial<LoggedUser>) { }
}



export class Action_Auth_SetAdminAccess implements StoreAction<Entity> {
  readonly type = AUTH_ACTION_TYPES.SET_ADMIN_ACCESS;
  constructor(public payload: Entity) { }
}

export class Action_Auth_UserEntityAdded implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.USER_DATA_ENTITY_ADDED;
}

export class Action_Auth_RetrieveUserData implements StoreAction<fUser> {
  readonly type = AUTH_ACTION_TYPES.RETRIEVE_LOGGED_USER_DATA;
  constructor(public payload: fUser) { }
}

export class Action_Auth_RetrieveUserData_Success implements StoreAction<User> {
  readonly type = AUTH_ACTION_TYPES.RETRIEVE_LOGGED_USER_DATA_SUCCESS;
  constructor(public payload: User) { }
}

export class Action_Auth_UserDataReloaded implements StoreAction<User> {
  readonly type = AUTH_ACTION_TYPES.USER_DATA_RELOADED;
  constructor(public payload: User) { }
}

export class Action_Auth_Signout implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNOUT;
}

export class Action_Auth_Signout_Success implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNOUT_SUCCESS;
}

export class Action_Auth_IsLoading implements StoreAction<string> {
  readonly type = AUTH_ACTION_TYPES.IS_LOADING;
  constructor(public payload?: string) { }
}

export class Action_Auth_SigninWithFacebook implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNIN_WITH_FACEBOOK;
}

export class Action_Auth_SigninWithFacebook_Success implements StoreAction<fUser> {
  readonly type = AUTH_ACTION_TYPES.SIGNIN_WITH_FACEBOOK_SUCCESS;
  constructor(public payload: fUser) { }
}

export class Action_Auth_SigninWithGoogle implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.SIGNIN_WITH_GOOGLE;
}

export class Action_Auth_ProfilePictureChanged implements StoreAction<string> {
  readonly type = AUTH_ACTION_TYPES.IMAGE_PROFILE_CHANGED;
  constructor(public payload: string) { }
}

export class Action_Auth_IsNotLoading implements StoreAction {
  readonly type = AUTH_ACTION_TYPES.IS_NOT_LOADING;
}

export type AuthAction =
  | Action_Auth_LoadCurrentFirebaseUser
  | Action_Auth_LoadCurrentFirebaseUser_Success
  | Action_Auth_LoadCurrentFirebaseUser_Empty
  | Action_Auth_Signout
  | Action_Auth_Signout_Success
  | Action_Auth_Signin
  | Action_Auth_Signin_Firebase_Success
  | Action_Auth_Signup
  | Action_Auth_Signup_Success
  | Action_Auth_EmailNotVerified
  | Action_Auth_UserDataChangedByStartup
  | Action_Auth_UserDataChangedByProfileForm
  | Action_Auth_RetrieveUserData
  | Action_Auth_RetrieveUserData_Success
  | Action_Auth_IsLoading
  | Action_Auth_IsNotLoading
  | Action_Auth_ProfilePictureChanged
  | Action_Auth_SigninWithFacebook
  | Action_Auth_SigninWithGoogle
  | Action_Auth_SetAdminAccess;
